export function getImageFilenameAndExtension(imagePath: string): {
  filename: string;
  extension: string;
} {
  const [filenameWithExtension] = imagePath.split('/').reverse();
  const [filename, extension] = filenameWithExtension.split('.');

  return { filename, extension };
}
